import { useAuth } from '../hooks/queries';
import { Spinner } from '../components/ui';
import { StudentDashboard } from './dashboard/StudentDashboard';
import { InstructorDashboard } from './dashboard/InstructorDashboard';

export function Dashboard() {
  const { user, isLoading } = useAuth();
  if (isLoading || !user) return <Spinner label="Loading your dashboard…" />;
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tight">Hi, {user.name.split(' ')[0]}</h1>
        <p className="text-sm text-mut">
          {user.role === 'instructor'
            ? 'Create classes and share join codes with your students.'
            : 'Join a class, form a team, and run your smart-watch company.'}
        </p>
      </div>
      {user.role === 'instructor' ? <InstructorDashboard /> : <StudentDashboard />}
    </div>
  );
}
